import axios from 'axios'
import qs from 'qs'
import { Message } from 'element-ui';
import { domain } from '../config'
import store from '@/vuex/store'
import SlsTracker from '@/v2/utils/sls'

let requestListMap = {}

axios.defaults.timeout = 600000
axios.defaults.baseURL = domain


// 请求时的拦截
axios.interceptors.request.use(config => {
	const { url, data, method } = config
	const headers = {
		'is-ajax-request': true,
		'Project-Id': 'region',
		'token': YJ_REGION_STORAGE.getItem('token') || '',
		'X-Yj-Request-Id': SlsTracker.getRequestId()
	}
	Object.assign(config.headers.common, headers)
	if (window.showUpdateTip) {
		window.showUpdateTip(Message)
	}
	if (SlsTracker.checkSlsUrl(method, url)) {
		SlsTracker.httpLog('HTTP_REQUEST_OLD', 'http请求信息', { config: { url, data, method, headers } })
	}
	// 统一添加上传进度监听
	config.onUploadProgress = progressEvent => {
		const progress = { loaded: progressEvent.loaded, total: progressEvent.total }
		SlsTracker.httpLog('HTTP_REQUEST_OLD', 'http请求进度', { config: { url, method, headers, progress } })
	}
	return config
}, function (error) {
	return Promise.reject(error)
})

axios.interceptors.response.use(resp => {
	const result = resp.data
	if (result) {
		const isSls = SlsTracker.checkSlsUrl(resp.config.method, resp.config.url)
		if (isSls) {
			SlsTracker.httpLog('HTTP_SUCCESS_OLD', 'http响应信息', resp)
		}
		if (result.code > 1000 || [0, 200, 400, 666, 500].indexOf(result.code) >= 0) {
			return result
		} else if (result.code === 431) { // 成功登录后，token过期，此时是正常响应，但是code=431，故这里也拦截下
			Message.error({
				message: '登录已过期，请重新登录',
				onClose: jumpLogin
			})
		} else {
			Message.error(result.message)
		}
	} else {
		SlsTracker.httpLog('HTTP_ERROR_OLD', 'http响应为空', resp)
		const message = `接口异常：${resp.statusText}`
		Message.error(message)
		console.error(message)
		console.error('请求信息：\n', resp.config)
		console.error('响应信息：\n', resp)
	}
}, error => {
	SlsTracker.httpLog('HTTP_ERROR_OLD', 'http响应错误', error)
	if (error.response) {
		const result = error.response.data
		const { url, method, data } = error.config
		console.error('接口入参：\n', url, method, data)
		console.error('响应信息：\n', result)
		if (result) {
			if (error.response.status === 401) {
				if (result.message === '未登录用户无权访问' || result.error === 'Unauthorized') {
					return result
				} else {
					Message.error({
						message: '登录已过期，请重新登录',
						onClose: jumpLogin
					})
				}
			} else if (result.code === 431 || result.code === 403) { // 首次登录，token无效（用token登录时），此时异常请求，若code=431，这里拦截下
				Message.error({
					message: '登录已过期，请重新登录',
					onClose: jumpLogin
				})
			} else {
				if (result.code && result.code > 1000) {
					return result
				} else {
					Message.error(result.message || result.error)
				}
			}
		} else {
			Message.error(error.statusText)
			return Promise.reject(error)
		}
	} else {
		Message.error('响应解析异常')
		return Promise.reject(error)
	}
})

axios.jsonp = (url, data) => {
	if (!url) {
		Message.warning('Axios.JSONP 至少需要一个url参数!')
		return
	}
	const callback = 'CALLBACK' + Math.random().toString().substr(9, 18)
	const JSONP = document.createElement('script')
	JSONP.setAttribute('type', 'text/javascript')
	const headEle = document.getElementsByTagName('head')[0]
	let ret = ''
	if (data) {
		if (typeof data === 'string') {
			ret = '&' + data
		} else if (typeof data === 'object') {
			for (const key in data) {
				ret += '&' + key + '=' + encodeURIComponent(data[key])
			}
		}
		ret += '&_time=' + Date.now()
	}
	JSONP.src = `${url}?callback=${callback}${ret}`
	return new Promise((resolve) => {
		window[callback] = r => {
			resolve(r)
			headEle.removeChild(JSONP)
			delete window[callback]
		}
		headEle.appendChild(JSONP)
	})
}

export default {
	get (url, params) {
		return axios({ method: 'get', url: getNewUrl(url), params })
	},
	post (url, datax, contentType) {
		const { headers, data } = headersAndData(contentType, datax)
		return axios({ method: 'post', headers, url: getNewUrl(url), data })
	},
	put (url, datax, contentType) {
		const { headers, data } = headersAndData(contentType, datax)
		return axios({ method: 'put', headers, url: getNewUrl(url), data })
	},
	delete (url, datax, contentType) {
		const { headers, data } = headersAndData(contentType, datax)
		return axios({ method: 'delete', headers, url: getNewUrl(url), data })
	},
	jsonp (url, params) {
		return new Promise((resolve, reject) => {
			axios.jsonp(getNewUrl(url), params).then(res => { resolve(res) }).catch(err => { reject(err) })
		})
	},
	postXkw (url, data) {
		return this.post(url, data).then(resp => {
			if (resp.body) {
				resp.result = resp.body.items
				resp.total = resp.body.totalSize
				resp.code = 200
			}
			return resp
		})
	},
	download: function (url) {
		return new Promise((resolve, reject) => {
			axios({
				headers: {
					'Cache-control': 'no-cache'
				},
				url: getNewUrl(url),
				method: 'GET',
				responseType: 'blob'
			}).then(data => {
				resolve(data.data || data)
			}).catch(error => {
				reject(error)
			})
		})
	},
	expired: function (url, params) {
		const message = 'Api1.5: 接口已过期'
		console.error(message)
		Message.error({ message: message + '\n' + url })
		return Promise.reject({
			code: 405,
			message: message,
			result: params
		})
	},
}

function jumpLogin () {
	let url = '/region/sso-login?type=logout'
	if (process.env.NODE_ENV === 'development') {
		url = 'http://yjdev.xkw.com' + url
		return
	}
	setTimeout(() => {
		window.needLogin = null
		window.open(url, '_self')
	}, 2 * 1000);
}

function headersAndData (contentType = 'json', data) {
	if (contentType === 'json') {
		return { headers: { 'Content-Type': 'application/json' }, data }
	} else {
		return { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, data: qs.stringify(data) }
	}
}

function getNewUrl (url) {
	const prefix = sessionStorage.getItem(url)
	if (store.state.backDoor && prefix) {
		return prefix + url
	} else {
		if (process.env.NODE_ENV === 'development' && url.indexOf(process.env.OSS_BUCKET) >= 0) {
			return url.replace('https://' + process.env.OSS_BUCKET + '.oss-cn-hangzhou.aliyuncs.com', location.origin + '/ali-oss')
		}
		return url
	}
}



// WEBPACK FOOTER //
// ./src/utils/http.js